import { render } from "./Detail.vue?vue&type=template&id=7462151e&ts=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=7462151e&lang=scss"

import exportComponent from "/Users/lxb/kuaike/kunpeng-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__